export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--5-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Sidebar.vue?vue&type=style&index=0&id=59b1cb4b&prod&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.vue?vue&type=style&index=0&id=59b1cb4b&prod&lang=css
// module id = aG9l
// module chunks = 1